import {  GET_FAILURE, GET_REQUEST, GET_SUCCESS } from "../actionTypes"

const init={
    isLoading:false,
    isError:false,
    data:[]
}

export const reducer=(state=init,{type,payload})=>{
      switch(type){
        case GET_REQUEST:{
          return{
            ...state,
            isLoading:true
          }
        }
        case GET_SUCCESS:{
          return{
            ...state,
            isLoading:false,
            data:payload
          }
        }
        case GET_FAILURE:{
          return{
            ...state,
            isLoading:false,
            isError:true
          }
        }
        default:return state
      }
}